import { Injectable } from "@angular/core";
import { Store } from '@ngrx/store';
import { ShippingState } from '../../../../../store/shipping/shipping.reducer';
import { BehaviorSubject, Observable } from "rxjs";
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResumenPedidoService {
  private tip: number = 0;
  private tipSubject = new BehaviorSubject<number>(0);
  private readonly TIP_KEY = 'delivery_tip';

  constructor(
    private store: Store<{ shipping: ShippingState }>,
  ) {}

  getShippingCost$(): Observable<number> {
    return this.store.select(state => state.shipping.shippingCost).pipe(
      map(cost => Number(cost))
    );
  }

  getDistance$(): Observable<number> {
    return this.store.select(state => state.shipping.kmDistance).pipe(
      map(distance => Number(distance))
    );
  }

  getTotalCost$(): Observable<number> {
    return this.store.select(state => state.shipping.totalCost).pipe(
      map(total => Number(total))
    );
  }

  getPercent$(): Observable<number> {
    return this.store.select(state => state.shipping.deliveryPercent).pipe(
      map(percent => Number(percent))
    );
  }

  setTip(tip: number) {
    this.tip = tip;
    this.tipSubject.next(tip);
  }

  getTip(): number {
    return this.tip;
  }

  getTip$(): Observable<number> {
    return this.tipSubject.asObservable();
  }
}







